import { Flex, Text, Heading } from "@chakra-ui/react"
import Plan from "./Plans"

const Pricing = ({ scrollRef }) => {
  return (
    <Flex
      width="100%"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      paddingTop="24px"
      paddingBottom="24px"
      ref={scrollRef}
    >
      <Heading marginBottom="16px" textAlign="center">
        Alege pachetul potrivit nevoilor tale
      </Heading>
      <Text textAlign="center">
        Pentru ca ne-ai cerut, noi iti prezentam{" "}
        <strong>pretul total al energiei, cu toate taxele incluse</strong>!
      </Text>
      <Flex
        flexDirection={["column", "column", "row", "row"]}
        width="80vw"
        justifyContent="space-evenly"
      >
        <Plan />
        <Plan isPlus={true} />
      </Flex>
    </Flex>
  )
}

export default Pricing
